export const DB_CONFIG = {
    apiKey: "AIzaSyA3uJgSSi61wbcR4c03wRw59dY0MlumX-Q",
    authDomain: "react-flashcards-13b93.firebaseapp.com",
    databaseURL: "https://react-flashcards-13b93.firebaseio.com",
    projectId: "react-flashcards-13b93",
    storageBucket: "",
    messagingSenderId: "895740558463",
    appId: "1:895740558463:web:3d04a26acf244bd3"
  };
